<template>
  <section class="home-block home-procurement">
    <div class="home-block__inner">
      <div class="home-block__head">
        <div class="home-block__titleBox">
          <h2 class="home-block__title">求购信息</h2>
          <div class="home-block__entitle">PURCHASE REQUEST INFORMATION</div>
        </div>
        <div class="home-block__setting" @click="toWantBuyCenter">
          <div class="home-block__toPurchase">前往求购中心></div>
          <div class="home-block__pagination"></div>
        </div>
      </div>
      <div class="home-block__body">
        <div class="home-block__procurement">
          <div
            class="push_box"
            :style="{
              backgroundImage: `url(${pushBg})`,
              backgroundSize: 'cover',
            }"
          >
            <div class="push_top">
              <div class="push_titleBox">
                <div class="push_title">发布求购单</div>
                <div class="push_titleEn">Issue purchase order</div>
              </div>
              <!-- <img src="@/assets/image/home/toIcon.png" alt="" /> -->
            </div>
            <div
              class="push_item"
              v-for="(item, index) in pushData"
              :key="index"
            >
              <div class="item_img">
                <img
                  :src="require(`@/assets/image/home/buy/${item.icon}.png`)"
                  alt=""
                />
              </div>
              <div class="item_title">{{ item.title }}</div>
            </div>
            <div class="push_button can_click" @click="toPushBuy">
              发布求购单
            </div>
          </div>
          <div class="buy_list_warp">
            <el-card
              v-for="(item, index) in procurementList"
              :key="index"
              class="procurement_item"
              @click.native="toWantBuyDetail(item)"
            >
              <div class="item_title" :title="item.theTitle">
                <el-tag class="tag1">{{ "运力求购" }}</el-tag
                >{{ item.theTitle }}
              </div>
              <div class="buy_status_tag">求购中</div>
              <div class="item_infoBox">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8">
                  <div class="item_info">
                    <img
                      class="info_img"
                      src="@/assets/image/home/buy_no_icon.png"
                      alt=""
                    />
                    <span class="info_content">求购单号：{{ item.theNo }}</span>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="9">
                  <div class="item_info">
                    <img
                      class="info_img"
                      src="@/assets/image/home/personIcon.png"
                      alt=""
                    />
                    <span class="info_content" v-if="!getToken()"
                      >买家名称：*******</span
                    >
                    <span class="info_content" v-else-if="isAuthLogistics()"
                      >买家名称：{{ item.companyName }}</span
                    >
                    <span class="info_content can_not_see" v-else
                      >买家名称：{{ "认证物流商后可查看买家名称" }}</span
                    >
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="7">
                  <div class="item_info">
                    <img
                      class="info_img"
                      src="@/assets/image/home/timeIcon.png"
                      alt=""
                    />
                    <span class="info_content"
                      >最晚交货日期：{{ item.lastDeliveryDate }}</span
                    >
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8">
                  <div class="item_info">
                    <img
                      class="info_img"
                      src="@/assets/image/home/money_icon.png"
                      alt=""
                    />
                    <span class="info_content"
                      >结算方式：{{ item.clearMethod }}</span
                    >
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="16">
                  <div class="item_info item_info2">
                    <img
                      class="info_img"
                      src="@/assets/image/home/tax_icon.png"
                      alt=""
                    />
                    <span class="info_content"
                      >税费说明：{{ item.saxDesc }}</span
                    >
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="24">
                  <div class="item_info item_info3">
                    <img
                      class="info_img"
                      src="@/assets/image/home/descIcon.png"
                      alt=""
                    />
                    <span class="info_content"
                      >概要说明：{{ item.summaryDesc }}</span
                    >
                  </div>
                </el-col>
              </div>
              <div class="item_statusBox">
                <div>
                  发布时间：{{item.createTime}}
                </div>
                <div class="buy_account">
                  求购总额：
                  <span class="buy_account_num">
                    ￥{{ item.buyBillMoney | moneyFormat }}
                  </span>
                </div>
              </div>
            </el-card>
            <slot v-if="procurementList.length === 0">
              <div class="home-block__empty">暂无数据</div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getToken } from "@/utils/auth";
import { getBuyList } from "@/api/home";
export default {
  name: "HomeWantBuy",
  data() {
    return {
      pushBg: require("@/assets/image/home/buy/home_buy_bg.png"),
      stepIcon1: require("@/assets/image/home/buy/step1.png"),
      stepIcon2: require("@/assets/image/home/buy/step2.png"),
      stepIcon3: require("@/assets/image/home/buy/step3.png"),
      stepIcon4: require("@/assets/image/home/buy/step4.png"),

      pushData: [
        {
          title: "买家发布求购需求",
          icon: "step1",
        },
        {
          title: "物流商浏览并抢单",
          icon: "step2",
        },
        {
          title: "完成抢单执行签约",
          icon: "step3",
        },
        {
          title: "履约完成闭环归档",
          icon: "step4",
        },
      ],
      loading: false,
      procurementData: [],
      procurementList: [],
      page: {
        size: 3,
        current: 1,
        total: 0,
      },
      timer: null, // 定时器
      now: Date.now(), // 当前时间戳，用于触发视图更新
    };
  },
  computed: {
    // 计算总页数
    totalPages() {
      if (this.page.total === 0) return 0;
      return Math.ceil(this.page.total / this.page.size);
    },
  },
  mounted() {
    this.getProcurementData();
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  created() {},
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    getToken,
    // 前往发布求购单
    toPushBuy() {
      console.log("发布求购单");
      // 校验是否登录
      if (getToken()) {
        console.log("已登录");
        // 判断是否实名认证
        if (this.isAuth()) {
          // 判断是否有买家身份
          if (this.isAuthBuyer()) {
            this.linkJump("/wantBuy/buyDeal");
          } else {
            this.linkJump("/tradersCenter", { needCertification: "buyer" });
          }
        } else {
          this.changeAuthVisible(true);
          console.log("未认证", this.$store.state.certVisible);
          return;
        }
      } else {
        this.linkJump("/wantBuy/buyDeal");
      }
    },
    // 前往求购中心
    toWantBuyCenter() {
      this.$router.push({
        path: "/wantBuy",
      });
    },
    async getProcurementData() {
      this.loading = true;
      const res = await getBuyList({ size: 2 });
      this.loading = false;
      if (res.data != null) {
        this.procurementList = res.data;
      } else {
        this.procurementList = [];
      }
    },
    updateCurrentPageData() {
      const start = (this.page.current - 1) * this.page.size;
      const end = start + this.page.size;
      //  slice 不会修改原数组，返回新数组
      this.procurementList = this.procurementData.slice(start, end);
    },
    getRemainingTimeStr(endTimeStr) {
      if (!endTimeStr) return "--";
      // 假设 endTimeStr 格式为 "yyyy-MM-dd HH:mm:ss" 或时间戳
      // 如果是字符串，需要转换为时间戳
      const endTime = new Date(endTimeStr).getTime();
      const currentTime = this.now; // 使用响应式的 now
      const diff = endTime - currentTime;
      // 如果已经结束
      if (diff <= 0) {
        return "已结束";
      }
      // 计算时分秒
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      // 补零格式化
      const h = hours.toString().padStart(2, "0");
      const m = minutes.toString().padStart(2, "0");
      const s = seconds.toString().padStart(2, "0");
      return `${h}:${m}:${s}`;
    },
    // 查看详情
    toWantBuyDetail(item) {
      if (getToken()) {
        console.log("已登录");
        // 判断是否实名认证
        if (this.isAuth()) {
          // 判断是否有物流商身份
          if (this.isAuthLogistics()) {
            this.linkJump("/wantBuy/buyDetail", { id: item.id });
          } else {
            // 判断订单中的userId 和 当前用户id是否一致
            if (this.isSameUser(item.userId)) {
              this.linkJump("/wantBuy/buyDetail", { id: item.id });
            } else {
              this.linkJump("/tradersCenter", {
                needCertification: "logistics",
              });
            }
          }
        } else {
          this.changeAuthVisible(true);
          console.log("未认证", this.$store.state.certVisible);
          return;
        }
      } else {
        this.linkJump("/wantBuy/buyDetail", { id: item.id });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";

// 主容器样式
.home-block {
  width: 100%;
  background: #ffffff;
  font-family: Source Han Sans CN, Source Han Sans CN;

  // 内部容器
  &__inner {
    width: @defaultWidth;
    margin: 0 auto;
    padding: 32px 0;
  }

  // 头部
  &__head {
    margin-bottom: 20px;
    padding-bottom: 12px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  // 标题区域
  &__titleBox {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  // 主标题
  &__title {
    font-weight: 500;
    font-size: 36px;
    color: #323233;
  }

  // 英文标题
  &__entitle {
    font-weight: 400;
    font-size: 22px;
    color: #cccccc;
  }

  // 设置区域
  &__setting {
    font-weight: 400;
    font-size: 14px;
    color: #3b75dd;
    display: flex;
    align-items: center;
  }

  // 前往求购中心
  &__toPurchase {
    font-weight: 400;
    font-size: 14px;
    color: #3b75dd;
    cursor: pointer;
  }

  // 分页
  &__pagination {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 40px;

    img {
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }

  // 主体内容
  &__body {
    min-height: 120px;
  }

  // 求购信息区域
  &__procurement {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  // 推送盒子
  .push_box {
    position: relative;
    width: 355px;
    height: 476px;
    box-sizing: border-box;
    padding: 30px;

    // 推送顶部
    .push_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      // 推送标题
      .push_titleBox {
        .push_title {
          font-weight: 500;
          font-size: 20px;
          color: #3b75dd;
        }

        .push_titleEn {
          font-weight: 400;
          font-size: 14px;
          color: #3b75dd;
          margin-top: 5px;
        }
      }

      img {
        width: 37px;
        height: 37px;
        cursor: pointer;
      }
    }

    // 推送项目
    .push_item {
      display: flex;
      align-items: center;
      text-align: center;
      position: relative;

      // 项目图片
      .item_img {
        width: 30px;
        height: 30px;
        position: relative;
        margin: 20px 10px 20px 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        // 上下线条
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -20px;
          width: 1px;
          height: 20px;
          background: #3b75dd;
        }

        &:after {
          content: "";
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -20px;
          width: 1px;
          height: 20px;
          background: #3b75dd;
        }
      }

      // 项目标题
      .item_title {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
      }
    }

    // 推送按钮
    .push_button {
      position: absolute;
      left: 30px;
      bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 110px;
      height: 33px;
      border-radius: 19px;
      border: 1px solid #3b75dd;
      font-weight: 400;
      font-size: 14px;
      color: #3b75dd;
    }
  }

  // 求购项目
  .procurement_item {
    flex: 1;
    position: relative;
    height: 228px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    ::v-deep .el-card__body {
      padding: 20px 25px;
    }
    // 标签样式
    .tag1 {
      margin-right: 15px;
      width: 76px;
      height: 28px;
      background: #ff954f;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      border: none;
    }

    .tag2 {
      width: 76px;
      height: 28px;
      background: #ff6d70;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      border: none;
    }

    // 项目标题
    .item_title {
      width: calc(100% - 86px);
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 26px;
      height: 56px;
      // margin: 0 0 30px 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    // 项目信息
    .item_info {
      width: calc(100% - 86px);
      // min-width: 315px;
      // max-width: 315px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      overflow: hidden;

      // 信息内容
      .info_content {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
      }

      // 信息图标
      .info_img {
        width: 19px;
        height: 19px;
        margin-right: 6px;
      }
    }

    // 信息项变体
    // .item_info2 {
    //   min-width: 630px;
    //   max-width: 630px;
    // }

    // .item_info3 {
    //   max-width: 945px;
    // }

    // 状态盒子
    .item_statusBox {
      // width: calc(100% - 60px);
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      padding-top: 10px;
      border-top: 1px solid #f0f0f0;
      // position: absolute;
      // bottom: 20px;
      font-weight: 400;
      font-size: 12px;
      color: #333333;

      .buy_account {
        font-weight: 400;
        font-size: 14px;
        color: #999999;

        .buy_account_num {
          font-weight: 500;
          font-size: 22px;
          color: #3b75dd;
        }
      }
    }
  }

  // 空状态
  &__empty {
    padding: 40px 0;
    text-align: center;
    color: #c0c4cc;
    font-size: 14px;
  }
}

// 购买列表容器
.buy_list_warp {
  height: 476px;
  flex: 1;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
}

// 求购状态标签
.buy_status_tag {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 0;
  width: 86px;
  height: 28px;
  background: rgba(255, 141, 40, 0.1);
  font-weight: 400;
  font-size: 14px;
  color: #ff8d28;
  border-radius: 15px 0 0 15px;
}

// 信息盒子
.item_infoBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>
